import { ExportSectionDropdown } from '@openx/components-deal/lib/DealInsights/components/DealInsightsPdfExport/components/ExportSectionDropdown.tsx';
import { DealInsightsProvider } from '@openx/components-deal/lib/DealInsights/context/DealInsightsContext.tsx';
import { DealInsights } from '@openx/components-deal/lib/DealInsights/DealInsights.tsx';
import { PageHeader } from '@openx/components-header/PageHeader.tsx';
import { useTranslation } from 'react-i18next';

export const DealInsightsPage = () => {
  const { t } = useTranslation();

  return (
    <DealInsightsProvider>
      <PageHeader title={t('Deal Insights')} titlePrefix="OpenXSelect" sticky render={ExportSectionDropdown}>
        <DealInsights />
      </PageHeader>
    </DealInsightsProvider>
  );
};
